<template>
  <transition
    :enterClass="$style.fadeUpEnter"
    :enterActiveClass="$style.fadeUpEnterActive"
    :leaveActiveClass="$style.fadeUpLeaveActive"
    :leaveToClass="$style.fadeUpLeaveTo"
  >
    <div
      :class="[$style[type], $style.loginAlert, alignClass]"
      v-if="message || $slots.default"
    >
      <div
        :class="$style.iconContainer"
        v-if="!centered"
      >
        <i :class="[iconClass, $style.alertIcon]" />
      </div>
      <CustomError
        v-if="isCustomErrorMessage"
        :errorMessage="message"
      />
      <div v-else-if="!$slots.default">
        {{ message }}
      </div>
      <slot v-else />
    </div>
  </transition>
</template>

<script>
import { LoginConsts } from 'client/util/Constants';
import Util from 'client/util/Util';

import CustomError from './CustomError.vue';

const { error, success } = LoginConsts.alertTypes;

export default {
  name: 'Alert',
  components: {
    CustomError,
  },
  props: {
    // Determines whether the alert uses a centered text style
    centered: {
      type: Boolean,
      default: false,
    },

    // The name of the error to display; if empty, alert is hidden
    message: {
      type: String,
      default: '',
    },

    // Determines what styles to use for the alert
    type: {
      type: String,
      default: error,
    },
  },
  computed: {
    alignClass() {
      if (this.type === error) {
        return this.$style.loginAlertCenter;
      }
      return this.centered ? this.$style.loginAlertCenter : this.$style.loginAlertLeft;
    },
    iconClass() {
      return this.type === success ? 'jc-actions-check' : 'jc-actions-alert';
    },
    isCustomErrorMessage() {
      if (!this.message) return false;
      try {
        const message = Util.tryParseJson(this.message);
        // Check if the message is a custom error
        return Util.isCustomErrorMessage(message);
      } catch {
        return false;
      }
    },
  },
};
</script>

<style module>
@value fadeTransition from 'css/transitions.css';
@value (jcGrey900, jcError, jcError100, jcSuccess, jcSuccess100) from 'css/brand-colors.css';
@value lightShadow from 'css/shadows.css';

.loginAlert {
  border-radius: 3px;
  box-shadow: lightShadow;
  color: jcGrey900;
  font-size: 0.75rem;
  font-weight: 600;
  margin-top: 1rem;
  position: relative;
}

.error {
  background: jcError100;
  border-left: 5px solid jcError;
}

.success {
  background: jcSuccess100;
  border-left: 5px solid jcSuccess;
}

.loginAlertLeft {
  border-left: 0;
  padding: 1rem;
  text-align: left;
}

.loginAlertCenter {
  border-left: 0;
  padding: 17.5px 30px;
  text-align: center;
}

.iconContainer {
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 45px;
}

.alertIcon {
  font-size: 21px;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
}

.fadeUpEnterActive,
.fadeUpLeaveActive {
  transition: fadeTransition;
}

.fadeUpEnter,
.fadeUpLeaveTo {
  opacity: 0;
  transform: translate(20px, 0);
}
</style>
